const INTEGRATION_STATUS = {
  CLI_MANAGED: 'CLI_MANAGED',
  STAGED_FOR_DELETE_ACTIVE: 'STAGED_FOR_DELETE_ACTIVE',
  STAGED_FOR_DELETE_PAUSED: 'STAGED_FOR_DELETE_PAUSED',
  NOT_DEPLOYED: 'NOT_DEPLOYED',
  STAGED_FOR_PAUSE: 'STAGED_FOR_PAUSE',
  STAGED_FOR_ACTIVATION: 'STAGED_FOR_ACTIVATION',
  PAUSED: 'PAUSED',
  ACTIVE: 'ACTIVE',
};

export default INTEGRATION_STATUS;
